var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data_chartmain"},[_c('Header'),_c('div',{staticClass:"databox"}),_c('Logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }